export default "/assets/images/book-shell.3a7b3994144ba376.png";